import React from 'react';
import foldStyle from './style';

export default function Subtitle() {
	let style = foldStyle();
	return <p style={style.subTextStyle()}>Body. Resistance. Ultimate. Gains.</p>;
}
